<app-iota-modal i18n-title title="Office data" [modalOptions]="modalOptions" (close$)="dialogRef.close()">
    <div modal-body class="p-5 flex flex-col gap-3">
        <app-section-header i18n-text text="Office data">
            <ng-container buttons>
                <button *ngIf="!editMode" (click)="edit()">
                    <iota-icon icon="pencil-square" class="text-primary"></iota-icon>
                </button>
                <button *ngIf="editMode" class="btn btn-accent" (click)="save()">
                    <iota-icon flaticon="floppy-disk" size="1x"></iota-icon>
                </button>
                <button *ngIf="editMode" class="btn btn-accent" (click)="resetValues()">
                    <iota-icon icon="x-mark"></iota-icon>
                </button>
            </ng-container>
        </app-section-header>

        <div class="w-full mb-10 grid grid-cols-2 justify-between items-start gap-2 gap-x-16">
            <div class="flex flex-row items-center gap-2">
                <span class="min-w-1/4" i18n>Office Name:</span>
                <input type="text" [disabled]="!editMode" class="flex-1 input input-bordered" [(ngModel)]="updatedOffice.name" />
            </div>

            <div class="flex flex-row items-center gap-2">
                <span class="min-w-1/4" i18n>Customer-Office-No.:</span>
                <input type="text" [disabled]="true" class="flex-1 input input-bordered" [(ngModel)]="updatedOffice.companyOfficeNumber" />
            </div>

            <div class="col-start-2 flex flex-row items-center gap-2">
                <input type="checkbox" class="checkbox" [disabled]="!editMode" [(ngModel)]="updatedOffice.deactivated" />
                <span i18n>Deactivate Office</span>
            </div>
        </div>

        <app-address-list
            [showAddressSubtitle]="false"
            [addresses]="updatedOffice?.addresses"
            (upsertAddress)="updateAddress($event)"
        ></app-address-list>
    </div>

    <div modal-footer class="flex flex-row grow justify-between items-center gap-2">
        <div class="grow"></div>
        <button class="btn btn-primary" (click)="dialogRef.close()" i18n>Close</button>
    </div>
</app-iota-modal>
